<div class="panel-content"
  [attr.aria-labelledby]="panelHeaderText"
>
  <button
    class="header-button"
    (click)="togglePanel()"
  >
    <iris-icon 
      [ngClass]="isPanelOpen ? 'arrow-down' : 'arrow-right'"
      name="chevron_right" 
      [size]="iconSize"
    ></iris-icon>

    <div class="header-text"> {{ panelHeaderText }} </div>
  </button>
  <div
    class="panel-body" 
    [ngClass]="isPanelOpen ? 'show' : 'hide'"
    [innerHTML]="expandableBodyText">
  </div>
</div>
